import React from "react";
import PropTypes from "prop-types";
import { Overlay } from "react-overlays";
import Tooltip from "./Tooltip";

function TooltipOverlay({ ...props }) {
  const { placement, onHide, show, container, rootClose, style, children } = props;

  return (
    <Overlay
      placement={placement}
      onHide={onHide}
      show={show}
      container={container}
      rootClose={rootClose}>
      {({ props }) => (
        <Tooltip placement={placement} customStyle={style} {...props}>
          {children}
        </Tooltip>
      )}
    </Overlay>
  );
}

TooltipOverlay.propTypes = {
  placement: PropTypes.string,
  onHide: PropTypes.func,
  show: PropTypes.bool,
  container: PropTypes.object,
  rootClose: PropTypes.bool,
  style: PropTypes.object,
  children: PropTypes.object,
};

export default TooltipOverlay;
